import validator from "../../validators/step1/validator";
import Content from "./Content";
import { IWizardStep } from "../../../../wizard/types";

export const createConfigStep1: IWizardStep = {
  width: "712px",
  titleConfig: {
    titleText: "Add course",
  },
  content: Content,
  validator: validator,
  stepName: "step1",
};
